<script>

    import { onMount, setContext } from "svelte";
    import TreeNode from"./components/tree/TreeNode.svelte"
    import SampleDescription from"./components/SampleDescription.svelte"
    import ResourceDescription from"./components/ResourceDescription.svelte"
    import ResourceLinkDescription from"./components/ResourceLinkDescription.svelte"
    import {dataBox} from "./stores/dataBox"
    import {connections} from "./stores/connections"
    import applications from "./stores/old_applicationdescriptions";

    // set from outside
	export let configuration;

	$: selected = undefined;

	$: theTree = $dataBox['navigation'];
	let appdescriptions = {}
	$: connectionList = $connections.sets[ configuration.connectionset || 'default'];

    function clickHandler(e) {
        console.log("clickHandler", e);
    }

    onMount(async function() {

         // get connectionsets
        if (configuration.connections){
            let conn = await fetch(configuration.connections);
            conn  = await conn.json();
            $connections.sets = conn;
        }

        // get applications
        let appdata = await fetch(configuration.details);
        appdescriptions  = await appdata.json();

       // get category tree
       let navdata = await fetch(configuration.navigation);
       let dataTree  = await navdata.json();

       // build selection tree
       initializeTreeNode (dataTree);
       $dataBox['navigation'] = dataTree;

       selected = dataTree;

    });

    /**
    * buld new children list containing the app descriptions instead of IDs
    */
    function initializeTreeNode (node) {
        if (node.children){
            let newChildren =[];
            node.children.forEach( child => {
                if (typeof child === 'string' || child instanceof String){
                    newChildren.push (appdescriptions[child]);
                    console.log('added app description')
                } else {
                    newChildren.push (child);
                    initializeTreeNode (child);
                }
            } );
            node.children = newChildren;
        }
    }
</script>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}
	.treesection {
    		border-width: 1px;
    		border-style: dashed;
            overflow: auto;
            padding:.8em;
            height:100%
    	}
</style>


<div class="row" style="height:660px">
    {#if theTree}
        <div class="col-lg-4 col-md-4 col-sm-12" style="height:100%">
            <div class="treesection">
                <TreeNode
                    bind:node={theTree}
                    bind:selectedElement={selected}
                    collapsable=false
                    hideRoot={configuration.hideRoot}/>
            </div>
        </div>

        {#if configuration.mode ==='resourceView'}
            <div class="col-lg-8 col-md-8 col-sm-12" style="height:100%">
                <ResourceDescription
                    bind:appdesc={selected}
                    connections={connectionList}>
                </ResourceDescription>
            </div>

         {:else if configuration.mode ==='resourceLinkView'}
                    <div class="col-lg-8 col-md-8 col-sm-12" style="height:100%">
                        <ResourceLinkDescription
                            bind:appdesc={selected}
                            connections={connectionList}>
                        </ResourceLinkDescription>
                    </div>
        {:else}
            <div class="col-lg-8 col-md-8 col-sm-12" style="height:100%">
                <SampleDescription
                    bind:appdesc={selected}
                    connections={connectionList}>
                </SampleDescription>
            </div>
        {/if}

    {:else}
        Initializing ...
    {/if}
</div>





